var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "project-layout"
  }, [_vm._t("default"), _vm.shownCreate ? _c('div', {
    staticClass: "project-card-empty",
    on: {
      "click": _vm.goToProjectCreate
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "project-card-label"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.create')) + " ")])]) : _vm._e()], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "project-card-icon-overlay"
  }, [_c('div', {
    staticClass: "project-card-icon"
  })]);
}]

export { render, staticRenderFns }